import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton } from "material-ui"
import strings from "../../../localization/strings"
import FileUpload from "../../../components/common/FileUpload"
import { IFileDocument } from "../../../models"

interface IProps {
    handleSave(file: IFileDocument): void
    handleClose(): void
}
interface IState {
    uploading: boolean
    file: IFileDocument
}

export default class UploadUserDetailsFileDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            uploading: false,
            file: null
        }
        autobind(this)
    }

    handleSave() {
        if (!this.state.file) return
        this.props.handleSave(this.state.file)
        this.props.handleClose()
    }

    render() {
        return (
            <Dialog
                open
                title={strings.New_File}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <FlatButton
                        data-intercom-target={"menu-Employees-Files--Btn-CloseDialog"}
                        label={strings.CANCEL}
                        secondary
                        onClick={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"menu-Employees-Files-Btn-SaveAdjustment"}
                        label={strings.SAVE}
                        primary
                        onClick={this.handleSave}
                        disabled={this.state.uploading}
                    />
                ]}
            >
                <div style={{ paddingTop: 20, display: "flex", justifyContent: "center" }}>
                    <FileUpload
                        onlyPdfImg
                        width={525}
                        height={175}
                        uploadAreaLabel={strings.Upload_New_File_Version}
                        fileDocumentId={null}
                        handleChangeFile={file => this.setState({ file })}
                        handleChangeloadStatus={uploading => this.setState({ uploading })}
                    />
                </div>
            </Dialog>
        )
    }
}